<template>
  <div class="flex flex-row">
    <transition name="fade" mode="out-in">
      <div
        v-if="multiSection && !menuOpenLeft"
        class="
          bg-grey-800
          w-16
          flex flex-col
          justify-between
          custom-scrollbars
          overflow-y-auto
        "
      >
        <div
          id="left_sidebar"
          class="flex flex-col justify-center items-center"
        >
          <div
            v-for="slot in topSlots"
            v-show="slot.icon"
            :id="slot.id"
            :key="slot.name"
            class="
              info-sm
              flex flex-col
              justify-center
              items-center
              text-center
              py-3
              leading-loose
              cursor-pointer
              w-full
            "
            :class="[
              { activeSideBar: correctedOpenSection === slot.name },
              slot.name.toLowerCase().replaceAll(' ', ''),
            ]"
            @click.stop="setOpen(slot.name)"
            @mouseover="onMouseOver(slot.name)"
            @mouseleave="onMouseLeave(slot.name)"
          >
            <component :is="slot.icon" class="h-6 w-6" />
            <span
              class="leading-normal"
              :class="{ 'text-white': slot.hasHoverEffect === 1 }"
              v-html="slot.name"
            ></span>
          </div>
        </div>
        <div class="flex flex-col justify-center items-center py-3">
          <div
            v-for="slot in bottomSlots"
            v-show="slot.icon"
            :key="slot.name"
            class="
              info-sm
              flex flex-col
              justify-center
              items-center
              py-3
              leading-loose
              cursor-pointer
              w-full
            "
            :class="{ '': openSection === slot.name }"
            @click="setOpen(slot.name)"
          >
            <component :is="slot.icon" class="h-6 w-6" />
            <span class="leading-normal">{{ slot.name }}</span>
          </div>

          <div
            v-for="menu in nativeMenus"
            v-show="menu.icon"
            :key="menu.name"
            class="
              info-sm
              flex flex-col
              justify-center
              items-center
              py-3
              leading-loose
              cursor-pointer
              w-full
            "
            :class="{
              activeSideBar: openSection === menu.name,
              // feedBackActive class is workaround for feedBack svg to display active colors correctly
              feedBackActive:
                menu.name === $t('frontend_feedback') &&
                openSection === menu.name,
            }"
            @click="setOpen(menu.name, true)"
          >
            <component :is="menu.icon" class="h-6 w-6" />
            {{ menu.name }}
          </div>

          <div
            id="app_switch_btn_sidebar"
            class="
              info-sm
              flex flex-col
              justify-center
              items-center
              py-3
              cursor-pointer
            "
            @click="openLeftSidebar"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 16 16"
              class="h-6 w-6"
            >
              <path
                fill="#A4A8C0"
                fill-rule="nonzero"
                d="M1.776 11.593c.98 0 1.775.842 1.775 1.88 0 1.039-.795 1.88-1.775 1.88-.981 0-1.776-.841-1.776-1.88 0-1.038.795-1.88 1.776-1.88zm6.214 0c.98 0 1.776.842 1.776 1.88 0 1.039-.795 1.88-1.776 1.88-.98 0-1.776-.841-1.776-1.88 0-1.038.795-1.88 1.776-1.88zm6.214 0c.981 0 1.776.842 1.776 1.88 0 1.039-.795 1.88-1.776 1.88-.98 0-1.775-.841-1.775-1.88 0-1.038.795-1.88 1.775-1.88zM1.776 5.953c.98 0 1.775.842 1.775 1.88 0 1.039-.795 1.88-1.775 1.88C.795 9.713 0 8.872 0 7.833c0-1.038.795-1.88 1.776-1.88zm6.214 0c.98 0 1.776.842 1.776 1.88 0 1.039-.795 1.88-1.776 1.88-.98 0-1.776-.841-1.776-1.88 0-1.038.795-1.88 1.776-1.88zm6.214 0c.981 0 1.776.842 1.776 1.88 0 1.039-.795 1.88-1.776 1.88-.98 0-1.775-.841-1.775-1.88 0-1.038.795-1.88 1.775-1.88zM1.776.313c.98 0 1.775.842 1.775 1.88 0 1.039-.795 1.88-1.775 1.88C.795 4.073 0 3.232 0 2.193 0 1.155.795.313 1.776.313zm6.214 0c.98 0 1.776.842 1.776 1.88 0 1.039-.795 1.88-1.776 1.88-.98 0-1.776-.841-1.776-1.88 0-1.038.795-1.88 1.776-1.88zm6.214 0c.981 0 1.776.842 1.776 1.88 0 1.039-.795 1.88-1.776 1.88-.98 0-1.775-.841-1.775-1.88 0-1.038.795-1.88 1.775-1.88z"
              />
            </svg>
          </div>
          <div
            v-if="!noExitButton"
            id="exit_btn_left_sidebar"
            class="
              info-lg
              flex flex-col
              justify-center
              items-center
              py-3
              cursor-pointer
            "
            @click="exit"
          >
            <span>{{ $t('frontend_exit') }}</span>
          </div>
          <div
            class="
              info-sm
              flex flex-col
              justify-center
              items-center
              leading-loose
              w-full
            "
          >
            BETA
          </div>
        </div>
      </div>
    </transition>
    <div
      class="bg-grey-900 flex flex-col"
      :class="{ 'absolute left-16 z-50': overlayOpenSections }"
    >
      <transition name="slideright" mode="out-in">
        <div v-for="section in openSections" :key="section.name">
          <div
            v-if="section.doNotOpen !== 1"
            class="relative"
            :class="{
              'w-80': !double && !collapsed,
              'w-160': double,
              'w-16': collapsed,
            }"
          >
            <div
              v-if="editingComponent"
              class="
                gp-mini-style-toggler
                bg-grey-800
                text-white text-xs
                rounded-bl overflow-hidden
              "
            >
              <div v-if="collapsed" class="flex flex-col">
                <button class="p-2 hover:bg-grey-900"
                  @click="$store.commit('toggleMiniStyleEditor')"
                  title="Maximize"
                >
                  <arrow-left class="fill-current w-4 h-4"></arrow-left>
                </button>
                <button @click="close" title="Close" class="p-2 hover:bg-grey-900"><close-icon class="w-4 h-4" /></button>
              </div>
              <button
                v-else
                @click="$store.commit('toggleMiniStyleEditor')"
                class="p-2 hover:bg-grey-900"
                title="Minimize"
              >
                <arrow-right class="fill-current w-4 h-4"></arrow-right>
              </button>
            </div>
            <div
              class="
                heading
                border-solid border-grey-800 border-b
                flex flex-row
                justify-between
              "
              v-if="!collapsed"
            >
              <div v-if="!fixed" class="flex flex-grow items-center h-16">
                <span class="px-4 cursor-pointer" @click="close()">
                  <back-icon v-if="closeIcon === 'BackIcon'" class="h-4 w-4" />
                  <close-icon v-else class="h-5 w-5" />
                </span>
                <div
                  v-if="!renamingBlock"
                  class="text-white font-semibold leading-tight"
                  :class="{ hidden: collapsed }"
                >
                  {{ customTitle || section.title || section.name }}
                  <div
                    class="rename-block"
                    v-if="isBlock"
                    @click="renameBlock()"
                  >
                    <edit-icon class="h-4 w-4"></edit-icon>
                  </div>
                </div>
                <div class="flex flex-grow" v-else>
                  <input
                    ref="blockName"
                    class="rename-block-title"
                    type="text"
                    v-model="inputTitle"
                    @blur="saveRenameBlock(false)"
                    @keydown.enter="saveRenameBlock"
                  />
                </div>
              </div>
              <div>
                <slot :name="section.slot + '_header'"></slot>
              </div>
            </div>
            <div
              class="flex flex-col flex-grow custom-scrollbars"
              :class="{ 'overflow-y-auto': !collapsed }"
              style="height: calc(100vh - 144px)"
            >
              <slot v-if="section.slot" :name="section.slot"></slot>
              <component :is="section.component" v-if="section.component" />
            </div>
          </div>
        </div>
      </transition>
    </div>
    <transition name="fade" mode="out-in">
      <side-bar-left v-if="menuOpenLeft" @closeSideBar="showCloseSideBar" />
    </transition>
  </div>
</template>

<style scoped>
.activeSideBar {
  background-color: #191c3c;
  fill: #fd6481;
  stroke: #fd6481;
}
.activeSideBar > svg > g > path,
.activeSideBar > svg > g > ellipse,
.activeSideBar > svg > g > rect {
  stroke: #fd6481;
}
.activeSideBar.settings > svg path {
  fill: #fd6481;
}
.feedBackActive > svg > g > path:first-child {
  fill: #fd6481;
}
.activeSideBar > svg > g > ellipse {
  fill: #fd6481;
}
.rename-block {
  display: inline-block;
  cursor: pointer;
  margin-left: 10px;
  position: relative;
  top: 4px;
}
.rename-block-title {
  background-color: rgba(0, 0, 0, 0);
  color: white;
  font-weight: bold;
  outline: none;
}
.rename-block-title:focus {
  border-bottom: 1px solid white;
}
.gp-mini-style-toggler {
  position: absolute;
  top: 0;
  left: -32px;
}
</style>
<script>
import { debounce, isString } from 'lodash';
import SideBarLeft from './SideBarLeft';
import CloseIcon from '../assets/close-icon-new.svg';
import BackIcon from '../assets/arrow.svg';
import EditIcon from '../assets/pencil.svg';
import CheckIcon from '../assets/check-icon.svg';
import FeedbackIcon from '../assets/feedback-icon.svg';
import ArrowLeft from '../assets/arrow-left.svg';
import ArrowRight from '../assets/arrow-right.svg';
import FeedbackMenu from './FeedbackMenu';

export default {
  name: 'SideBar',
  components: {
    CloseIcon,
    EditIcon,
    CheckIcon,
    SideBarLeft,
    FeedbackIcon,
    FeedbackMenu,
    BackIcon,
    ArrowLeft,
    ArrowRight
  },
  props: {
    closeIcon: {
      default: 'CloseIcon'
    },
    initialOpen: {},
    sections: {},
    title: {},
    double: {},
    fixed: {},
    noExitButton: { default: false },
    isBlock: { default: false },
    noContent: { default: false },
    editBlockTitle: {},
    componentId: {},
    collapsed: { type: Boolean, default: false },
    editingComponent: { type: Boolean, default: false }
  },
  data() {
    return {
      overlayOpenSections: null,
      openSection: null,
      slots: [],
      menuOpenLeft: false,
      renamingBlock: false,
      inputTitle: '',
      nativeMenus: [
        {
          icon: FeedbackIcon,
          name: this.$t('frontend_feedback'),
          title: this.$t('frontend_send_feedback'),
          component: FeedbackMenu
        }
      ]
    };
  },
  computed: {
    multiSection() {
      return Array.isArray(this.sections);
    },
    openSections() {
      return [...this.slots, ...this.nativeMenus].filter(section => section.name === this.openSection);
    },
    topSlots() {
      return this.slots.filter(slot => slot.isBottom !== 1);
    },
    bottomSlots() {
      return this.slots.filter(slot => slot.isBottom === 1);
    },
    customTitle() {
      return this.inputTitle || this.title;
    },
    correctedOpenSection() {
      if (this.openSection === 'Edit Popup') return 'Popups';

      return this.openSection;
    }
  },
  created() {
    if (this.multiSection) {
      this.slots = this.sections.map(section => ({
        ...section,
        slot: section.name
      }));
    } else {
      this.slots = [{ name: this.sections, slot: 'default' }];
    }

    if (this.multiSection && this.initialOpen) {
      const openSectionObject = this.slots.find(slot => slot.name === this.initialOpen);

      this.openSection = this.initialOpen;
    } else if (typeof this.initialOpen !== 'undefined') {
      this.openSection = this.sections;
    }
  },
  methods: {
    setOpen(name, isNativeMenu = false) {
      if (this.correctedOpenSection !== name) {
        const openSectionObject = this.slots.find(slot => slot.name === name);

        if (!this.noContent || isNativeMenu) this.openSection = name;

        if (name === 'Popups' && this.activePopup && this.activePopup.pageId) this.openSection = 'Edit Popup';

        this.$nextTick(() => {
          this.$emit('open', name);
        });
      }
    },
    close() {
      const toClose = this.openSection;
      if (!this.openSection) return;
      this.openSection = null;
      this.renamingBlock = false;
      this.$nextTick(() => {
        this.$emit('close', toClose);
      });
    },
    open() {
      if (this.initialOpen) this.openSection = this.initialOpen;
      else if (this.multiSection) this.openSection = this.sections[0];
      else this.openSection = this.sections;
      this.$nextTick(() => {
        this.$emit('open', this.openSection);
      });
    },
    openLeftSidebar() {
      this.menuOpenLeft = true;
      this.openSection = null;
    },
    exit() {
      window.location.replace('/');
    },
    showCloseSideBar(payload) {
      this.menuOpenLeft = payload;
    },

    onMouseOver(name) {
      if (isString(this.openSection)) return; // to prevent re-render and closing of opened scection when a section is in open state

      this.$nextTick(() => {
        this.$emit('mouseOverMenuItem', name);
      });
    },

    onMouseLeave(name) {
      if (isString(this.openSection)) return;

      this.$nextTick(() => {
        this.$emit('mouseLeaveMenuItem', name);
      });
    },
    renameBlock() {
      this.renamingBlock = true;
      this.$nextTick(() => {
        this.$refs.blockName[0].focus();
      });
    },
    saveRenameBlock(save = true) {
      this.renamingBlock = false;
      if (save) this.$emit('editBlockTitle', this.inputTitle);
    }
  },
  watch: {
    title: {
      deep: true,
      handler(newValue, oldValue) {
        this.renamingBlock = false;
        if (oldValue !== newValue) this.inputTitle = newValue;
      }
    },
    componentId: {
      deep: true,
      handler(newValue, oldValue) {
        if (oldValue !== newValue) this.renamingBlock = false;
      }
    }
  }
};
</script>
